import { render, staticRenderFns } from "./fragment-radiobutton.vue?vue&type=template&id=25c5d34f&scoped=true&"
import script from "./fragment-radiobutton.vue?vue&type=script&lang=js&"
export * from "./fragment-radiobutton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c5d34f",
  null
  
)

export default component.exports